var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31.5px",
    height: "31.5px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slozka-list-190415",
    transform: "translate(-1115.000000, -224.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(1116.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vytvorit-slozku"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,40 C8.9725,40 0,31.0275 0,20 C0,8.9725 8.9725,0 20,0 C31.0275,0 40,8.9725 40,20 C40,31.0275 31.0275,40 20,40 Z",
    id: "Path-Copy-2",
    stroke: "currentColor",
    strokeWidth: 1.11999991
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.996,17.4 L30.6,17.4 L30.6,14.8928 C30.6,14.29 30.1096,13.8 29.5072,13.8 L19.606,13.8 L17.606,11 L10.0928,11 C9.4904,11 9,11.4904 9,12.0928 L9,29.5676 L9.0024,29.5676 C9.0004,29.7928 9.0704,30.0132 9.2112,30.1976 C9.4072,30.4536 9.704,30.6 10.026,30.6 L27.9296,30.6 C28.392,30.6 28.7992,30.2884 28.9096,29.8748 L33,18.6596 L33,18.5888 C33,17.9 32.5776,17.4 31.996,17.4 Z M9.8,12.0928 C9.8,11.9312 9.9316,11.8 10.0928,11.8 L17.194,11.8 L19.194,14.6 L29.5068,14.6 C29.6684,14.6 29.7996,14.7312 29.7996,14.8928 L29.7996,17.4 L14.0924,17.4 C14.0348,17.4 13.9776,17.4048 13.922,17.4144 C13.5328,17.4796 13.2092,17.7636 13.1128,18.1248 L9.8,27.1596 L9.8,12.0928 Z M28.1476,29.6332 C28.1212,29.7312 28.0312,29.8 27.9296,29.8 L10.026,29.8 C9.9288,29.8 9.872,29.7444 9.8468,29.7112 C9.8216,29.6784 9.7828,29.6088 9.7976,29.548 L13.874,18.3668 C13.9004,18.2688 13.9904,18.2 14.092,18.2 L30.6,18.2 L31.996,18.2 C32.148,18.2 32.1868,18.4184 32.1968,18.5276 L28.1476,29.6332 Z",
    id: "Shape",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIconRound);
export default __webpack_public_path__ + "static/media/FolderIconRound.02f24887401ff48286906413d49f98ba.svg";
export { ForwardRef as ReactComponent };